module.exports = __webpack_public_path__ + "img/d98aa56.png";